/**
 * Created by Jiu Chen on 01/10/2019.
 * Description:
 *
 * ------ maintenance history ------
 */
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AppState } from '../../../redux';
import { ThreadDetailConfig } from '../../../components/thread-detail/thread-detail.view-model';
import { ThreadViewActionTypes } from '../../../redux/actions/thread-view.actions';
import { threadViewDataSelector, threadViewLastActionSelector } from '../../../redux/reducers/thread-view.reducer';
import { ScreenActionTypes } from '../../../redux/actions/screen.actions';
import { lastCustomActionSelector } from '../../../redux/reducers/action-history.reducer';
import { DELETE_NOTE_SUCCESS, CREATE_NOTE_SUCCESS, UPDATE_NOTE_SUCCESS, DELETE_ATTACHMENT_SUCCESS } from '../../../tamalelibs/redux/note.actions';
import { ToastService } from '../../../widgets/toast/toast.service';
import { businessConstants } from '../../../constants/business.constants';
import { NotificationStyles } from '../../../widgets/notification/notification.model';
import { PlatformRedirectionService } from '../../../services/platform-redirection.service';

@Component({
    selector: 'tam-thread-view',
    templateUrl: './thread-view.component.html',
    styleUrls: ['./thread-view.component.scss']
})
export class ThreadViewComponent implements OnInit, OnDestroy {

    threadDetailConfig = new ThreadDetailConfig();
    isLoading = false;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _store: Store<AppState>,
        private _toast: ToastService,
        private _platformRedirectService: PlatformRedirectionService) {
    }

    ngOnInit() {
        this._platformRedirectService.redirectIfOnMobile();
        this.threadDetailConfig.singlePageMode = true;
        this.threadDetailConfig.dataStoreSelector = threadViewDataSelector;

        this._destroySubscriptions.push(
            this._store.pipe(
                select(threadViewLastActionSelector)
            ).subscribe(action => this._onSubscribeActionMessage(action))
        );

        this._destroySubscriptions.push(
            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => this._actionMessageHandler(action))
        );

        this._getThread();

        const currentPageInfo: any = {
            url: this._route.snapshot.url,
            name: 'Thread View',
            type: 'THREAD_VIEW'
        };
        this._store.dispatch({
            type: ScreenActionTypes.SET_VALUE,
            payload: currentPageInfo
        });

        this.isLoading = true;
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    private _actionMessageHandler(action) {
        if (action.type === DELETE_NOTE_SUCCESS || action.type === DELETE_NOTE_SUCCESS) {
            this._toast.notify({
                message: businessConstants.note.deleteSuccessfully,
                style: NotificationStyles.Success
            });
            this._router.navigate(['/error']);
        } else if (action.type === DELETE_ATTACHMENT_SUCCESS) {
            this._toast.notify({
                message: 'Attachment successfully deleted.',
                style: NotificationStyles.Success
            });
        } else if (action.type === CREATE_NOTE_SUCCESS || action.type === UPDATE_NOTE_SUCCESS) {
            this._getThread();
            this.isLoading = true;
        }
    }

    private _onSubscribeActionMessage(action) {
        if (action === ThreadViewActionTypes.GET_THREAD_SUCCESS) {
            this.isLoading = false;
        } else if (action === ThreadViewActionTypes.GET_THREAD_FAILED) {
            this._router.navigate(['/error']);
        }
    }

    private _getThread() {
        this._store.dispatch({
            type: ThreadViewActionTypes.GET_THREAD,
            payload: this._route.snapshot.paramMap.get('id')
        });
    }
}
